import { Layout, Server, Database, Sparkles, Cpu } from "lucide-react";
import Section, { SectionHeading } from "../ui/Section";
import { useApp } from "../../context/AppContext";

const highlights = [
  { icon: Layout, key: "frontend" },
  { icon: Server, key: "backend" },
  { icon: Database, key: "data" },
  { icon: Sparkles, key: "ai" },
];

export default function About() {
  const { t, locale } = useApp();

  const stats = [
    { value: t("about.stat1.value"), label: t("about.stat1.label") },
    { value: t("about.stat2.value"), label: t("about.stat2.label") },
    { value: t("about.stat3.value"), label: t("about.stat3.label") },
  ];

  const pillars =
    locale === "es"
      ? ["Frontend", "Backend", "Bases de datos", "IA aplicada"]
      : ["Frontend", "Backend", "Databases", "Applied AI"];

  return (
    <Section id="about">
      <SectionHeading tag={t("about.tag")} title={t("about.title")} />
      <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr]">
        <div>
          <p className="text-base leading-relaxed text-soft sm:text-lg">{t("about.p1")}</p>
          <p className="mt-4 text-base leading-relaxed text-soft sm:text-lg">{t("about.p2")}</p>

          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {highlights.map((h, i) => (
              <div
                key={h.key}
                className="rounded-2xl border border-soft card-bg p-4 transition-transform hover:-translate-y-1"
              >
                <h.icon className="mb-2 h-6 w-6 text-cyan-400" strokeWidth={1.8} />
                <p className="text-sm font-semibold">{pillars[i]}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <div className="relative overflow-hidden rounded-3xl border border-soft bg-gradient-to-br from-cyan-500/10 via-transparent to-purple-500/10 p-6">
            <Cpu className="mb-4 h-10 w-10 text-cyan-400" strokeWidth={1.5} />
            <div className="grid grid-cols-3 gap-4">
              {stats.map((s) => (
                <div key={s.label}>
                  <p className="font-display text-2xl font-bold gradient-text sm:text-3xl">{s.value}</p>
                  <p className="mt-1 text-xs leading-snug text-soft">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-3xl border border-soft card-bg p-6">
            <pre className="overflow-x-auto font-mono text-xs leading-relaxed text-soft">
{`const daniel = {
  role: "Senior FE / Full-Stack",
  stack: ["React", "TS", "Laravel",
          "FastAPI", "SQL Server"],
  ai: ["RAG", "predictive", "assistants"],
  focus: "real business products",
};`}
            </pre>
          </div>
        </div>
      </div>
    </Section>
  );
}
